export default __webpack_public_path__ + "static/media/CAFETonic.35eb317bb99e53059c799c79eaf355fa.webp";